import React, { useState, useEffect } from "react";
import "./Navbar.css";
import {
  home,
  homeL,
  hamburgerMenu,
  hamburgerMenuL,
  close,
  closeL,
} from "../../assets/";
import "../../i18n";
import { useTranslation } from "react-i18next";
import useLocalStorage from "use-local-storage";

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const initialTheme = localStorage.getItem("theme") || "dark";
  const [isLightMode, setIsLightMode] = useState(initialTheme === "dark");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", initialTheme);
  }, [initialTheme]);

  const toggleTheme = () => {
    const newTheme = isLightMode ? "light" : "dark";
    setIsLightMode(!isLightMode);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  useEffect(() => {
    const anchors = document.querySelectorAll('a[href^="#"]');
    const handleScroll = (e) => {
      e.preventDefault();

      const targetId = e.currentTarget.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };

    anchors.forEach((anchor) => anchor.addEventListener("click", handleScroll));

    return () => {
      anchors.forEach((anchor) =>
        anchor.removeEventListener("click", handleScroll)
      );
    };
  }, []);

  const [isActive, setIsActive] = useState(false);

  return (
    <>
      <nav>
        <a href="#home" className="home">
          <img
            className="icon-color"
            src={isLightMode ? home : homeL}
            alt="Home"
          />
        </a>
        <ul>
          <li>
            <a href="#about">{t("about")}</a>
          </li>
          <li>
            <a href="#career">{t("career")}</a>
          </li>
          <li>
            <a href="#skills">{t("skills")}</a>
          </li>
          <li>
            <a href="#projects">{t("projects")}</a>
          </li>
          <li>
            <a href="#contact">{t("contact")}</a>
          </li>
          <li>
            <label className="theme-switch">
              <input
                type="checkbox"
                className="theme-switch__checkbox"
                onChange={toggleTheme}
                checked={isLightMode}
              />
              <div className="theme-switch__container">
                <div className="theme-switch__clouds"></div>
                <div className="theme-switch__stars-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 144 55"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M135.831 3.00688C135.055..."
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <div className="theme-switch__circle-container">
                  <div className="theme-switch__sun-moon-container">
                    <div className="theme-switch__moon">
                      <div className="theme-switch__spot"></div>
                      <div className="theme-switch__spot"></div>
                      <div className="theme-switch__spot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </label>
          </li>
          <li className="language-switcher">
            <select
              onChange={(e) => i18n.changeLanguage(e.target.value)}
              defaultValue={i18n.language}
            >
              <option className="languageChangeText" value="en">
                EN
              </option>
              <option className="languageChangeText" value="pl">
                PL
              </option>
            </select>
          </li>
        </ul>
        <div onClick={() => setIsActive(true)} className="hamburger-menu">
          <img
            src={isLightMode ? hamburgerMenu : hamburgerMenuL}
            alt="HamburgerMenu"
          />
        </div>
      </nav>
      <div className={`mobile-menu-container ${isActive ? "active" : ""}`}>
        <div onClick={() => setIsActive(false)} className="close-icon">
          <img src={isLightMode ? close : closeL} alt="CloseIcon" />
        </div>
        <ul className="menu-items">
          <li>
            <a href="#about" onClick={() => setIsActive(false)}>
              {t("about")}
            </a>
          </li>
          <li>
            <a href="#career" onClick={() => setIsActive(false)}>
              {t("career")}
            </a>
          </li>
          <li>
            <a href="#skills" onClick={() => setIsActive(false)}>
              {t("skills")}
            </a>
          </li>
          <li>
            <a href="#projects" onClick={() => setIsActive(false)}>
              {t("projects")}
            </a>
          </li>
          <li>
            <a href="#contact" onClick={() => setIsActive(false)}>
              {t("contact")}
            </a>
          </li>
          <li>
            <label className="theme-switch">
              <input
                type="checkbox"
                className="theme-switch__checkbox"
                onChange={() => {
                  toggleTheme();
                  setIsActive(false);
                }}
                checked={isLightMode}
              />
              <div className="theme-switch__container">
                <div className="theme-switch__clouds"></div>
                <div className="theme-switch__stars-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 144 55"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M135.831 3.00688C135.055..."
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <div className="theme-switch__circle-container">
                  <div className="theme-switch__sun-moon-container">
                    <div className="theme-switch__moon">
                      <div className="theme-switch__spot"></div>
                      <div className="theme-switch__spot"></div>
                      <div className="theme-switch__spot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </label>
          </li>
          <li className="language-switcher">
            <select
              onChange={(e) => {
                i18n.changeLanguage(e.target.value);
                setIsActive(false);
              }}
              defaultValue={i18n.language}
            >
              <option className="languageChangeText" value="en">
                EN
              </option>
              <option className="languageChangeText" value="pl">
                PL
              </option>
            </select>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
